module.exports = __webpack_public_path__ + "img/i-novativ.1406fa37.jpg";